<template>
  <div class="coaches-page">
    <h2 class="page-title">教练账号</h2>
    <el-card>
      <p class="intro">给教练开通登录账号后，教练用「馆码 + 账号 + 密码」登录即可给有小课的孩子划课。带课教练可在报名时选填。旧教练显示未开账号时，点开通补上即可。</p>
      <div class="toolbar">
        <el-button type="primary" size="small" @click="openEdit()">新增教练并开账号</el-button>
      </div>
      <el-table :data="list" v-loading="loading" border stripe>
        <el-table-column prop="name" label="姓名" min-width="100" />
        <el-table-column label="登录账号" min-width="140">
          <template slot-scope="{ row }">{{ row.loginUsername || '—' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="{ row }">
            <el-tag :type="row.hasLoginAccount ? 'success' : 'warning'" size="mini">
              {{ row.hasLoginAccount ? '已开账号' : '未开账号' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">{{ row.hasLoginAccount ? '改账号/密码' : '开通账号' }}</el-button>
            <el-button type="text" style="color:#f56c6c" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!loading && !list.length" class="empty">还没有教练，请先新增</div>
    </el-card>

    <el-dialog
      :title="form.id ? (form.hasLoginAccount ? '改账号 / 密码' : '开通教练账号') : '新增教练并开账号'"
      :visible.sync="visible"
      width="480px"
      append-to-body
      destroy-on-close
    >
      <el-form label-width="90px">
        <el-form-item label="姓名" required>
          <el-input v-model="form.name" maxlength="50" placeholder="教练姓名" />
        </el-form-item>
        <el-form-item label="登录账号" required>
          <el-input v-model="form.loginUsername" maxlength="50" placeholder="教练用来登录的账号" />
        </el-form-item>
        <el-form-item :label="needPassword ? '初始密码' : '重置密码'" :required="needPassword">
          <el-input
            v-model="form.loginPassword"
            type="password"
            maxlength="50"
            :placeholder="needPassword ? '至少 6 位' : '不填则不改密码'"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAdminCoaches, saveCoach, deleteCoach } from '../api'

export default {
  name: 'Coaches',
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      visible: false,
      form: {}
    }
  },
  computed: {
    needPassword() {
      return !this.form.id || !this.form.hasLoginAccount
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listAdminCoaches({ page: 1, size: 100 })
        this.list = (res.data && res.data.records) || []
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      this.form = row
        ? { ...row, loginPassword: '' }
        : { name: '', loginUsername: '', loginPassword: '', status: 1, sortOrder: 0 }
      this.visible = true
    },
    async save() {
      if (this.saving) return
      if (!this.form.name) return this.$message.warning('请填写姓名')
      if (!this.form.loginUsername) return this.$message.warning('请填写登录账号')
      if (this.needPassword && (!this.form.loginPassword || String(this.form.loginPassword).length < 6)) {
        return this.$message.warning('初始密码至少 6 位')
      }
      if (this.form.loginPassword && String(this.form.loginPassword).length < 6) {
        return this.$message.warning('密码至少 6 位')
      }
      this.saving = true
      try {
        await saveCoach(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    remove(row) {
      this.$confirm('确认删除该教练？绑定该教练的小课学员需先改绑。', '提示').then(async () => {
        await deleteCoach(row.id)
        this.$message.success('已删除')
        this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 16px; }
.intro { font-size: 13px; color: #64748B; line-height: 1.6; margin: 0 0 12px; }
.toolbar { margin-bottom: 12px; }
.empty { text-align: center; color: #94A3B8; padding: 24px 0; }
</style>
